
<bt-loader [loaderId]="photographerOrdersLoader">
  @if(photographerOrders.total){
        <bt-table [dataSource]="photographerOrders.orders" [displayedColumns]="orderColumns" />
      }@else{
        <div class="alert-container">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>Non sono stati trovati ordini passati per questo fotografo!</span>
        </div>
      }
</bt-loader>

<ng-template #orderDueDateColumn let-row="row">
  <span>{{ row.dueDate | date: 'dd/MM/yyyy'}}</span>
</ng-template>
